
import React from 'react';
import { Typography, Image } from 'antd';
import { AnalysisResult, AnalysisStatus } from '../../../types';

const { Text } = Typography;

interface ImageAnalysisProps {
  results: AnalysisResult;
  status: AnalysisStatus;
}

const ImageAnalysis: React.FC<ImageAnalysisProps> = ({ results, status }) => {
  const { image_analysis } = results;

  if (status === 'error') {
    return <Text>There was an unexpected error with image analysis, once the report is complete, please rerun the analysis.</Text>;
  } else if (status === 'skipped') {
    return <Text>Image analysis was skipped by the user.</Text>;
  }

  if (!image_analysis) {
    return <Text>No image analysis data available.</Text>;
  }

  return (
    <div>
      {image_analysis.problems && image_analysis.problems.length > 0 ? (
        <ul>
          {image_analysis.problems.map((problem: any, index: number) => (
            <li key={index} style={{ marginBottom: '16px', padding: '12px', border: '1px solid #f0f0f0', borderRadius: '6px' }}>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                {problem.image_url && (
                  <div style={{ flexShrink: 0 }}>
                    <Image
                      width={100}
                      height={75}
                      src={problem.image_url}
                      alt={problem.problem}
                      style={{ objectFit: 'cover', borderRadius: '4px' }}
                    />
                  </div>
                )}
                <div>
                  <Text strong style={{ fontSize: '16px' }}>{problem.problem}</Text>
                  <br />
                  <Text type="secondary">Severity: {problem.severity} | Location: {problem.position}</Text>
                  <br />
                  <Text type="secondary">Description: {problem.evidence}</Text>
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <Text type="secondary">No issues found in images.</Text>
      )}
    </div>
  );
};

export default ImageAnalysis;
